import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";
import HeroSlider from "@/pages/home/components/HeroSlider";
import IntroSection from "@/pages/home/components/IntroSection";
import ServiceCards from "@/components/feature/ServiceCards";
import AboutSection from "@/pages/home/components/AboutSection";
import ContactCTA from "@/pages/home/components/ContactCTA";

export default function HomeEsPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageHead
        title="NetBasis International - linking people & business"
        description="Entrada de mercado exitosa y crecimiento B2B para fabricantes extranjeros de TIC en Alemania, Austria y Suiza."
        ogUrl="https://net-basis.net/es"
      />
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        <HeroSlider
          texts={{
            slide1_title: "Nuevos mercados, nuevos negocios ... ¡sin riesgo!",
            slide2_title: "¡Con nosotros, en el corazón de Europa!",
            slide3_title: "Alemania (DACH): ¡Su éxito con un socio local!",
            slide4_title: "¡Juntos más fuertes!",
            slide4_subtitle: "Desarrollo de negocio\nConsultoría\nInterim Management\nFormación y coaching",
            slide5_title: "¡Iniciar ahora!",
            prev_slide: "Diapositiva anterior",
            next_slide: "Diapositiva siguiente",
            slide_label: "Diapositiva {{number}}",
            alts: [
              "Un dedo toca un globo digital conectado para entrar con bajo riesgo en el mercado TIC.",
              "Un dedo marca Europa en un mapa mundial conectado para la entrada en el mercado TIC.",
              "Mapa azul de Alemania con estados federados para una alianza TIC en el mercado DACH.",
              "Un empresario usa una interfaz digital para servicios TIC al entrar en el mercado DACH.",
              "Un dedo activa un icono digital de inicio para una entrada exitosa en el mercado TIC europeo.",
            ],
          }}
        />

        <IntroSection
          texts={{
            title: "NetBasis International - linking people & business",
            heading:
              "Su socio operativo para una entrada exitosa en el mercado de la región DACH. Apoyamos y gestionamos sus actividades locales a medida, ya sea asumiendo la gestión integral de sus operaciones o de forma flexible en áreas funcionales específicas.",
            paragraph1:
              "El desarrollo, el crecimiento y la expansión de negocios en nuevos mercados deben ser, ante todo, sinónimo de éxito, rapidez, eficiencia, rentabilidad y seguridad para las empresas extranjeras. Los estudios de mercado prolongados, las estrategias complejas con procesos de toma de decisiones poco claros o la falta de acceso directo al mercado objetivo constituyen invariablemente el enfoque equivocado. Además, los fabricantes a menudo desean entrar en un nuevo mercado sin realizar grandes inversiones iniciales.",
            paragraph2:
              "Precisamente aquí es donde NetBasis International se posiciona como el socio ideal a su lado. Desde hace casi 20 años, acompañamos y apoyamos con éxito a empresas extranjeras del sector de las TIC en mercados atractivos pero exigentes, con un enfoque claro en el espacio económico de habla alemana (la región DACH).",
            strong_name: "NetBasis International",
          }}
        />

        <ServiceCards
          namespace="home"
          titleKeys={[
            "services.service1_title",
            "services.service2_title",
            "services.service3_title",
            "services.service4_title",
          ]}
          descriptionKeys={[
            "services.service1_description",
            "services.service2_description",
            "services.service3_description",
            "services.service4_description",
          ]}
          readMoreKey="services.read_more"
          texts={{
            titles: [
              "Desarrollo de negocio",
              "Consultoría",
              "Interim Management",
              "Formación y coaching",
            ],
            descriptions: [
              "¿Éxito en el mercado DACH? ¡Le abrimos el camino! Con nosotros, las puertas se abrirán. ¡Actuamos y lo logramos!",
              "¿Saber cómo se hace? ¡Le damos claridad! Asesoramos con visión de futuro. ¡Protegemos su proyecto!",
              "¿Necesidad temporal? ¡La cubrimos con solvencia! Cerramos la brecha. ¡Le damos total seguridad!",
              "¿Nuevos mercados en la mira? ¡Lo preparamos! Entrenamos para la práctica. ¡Aseguramos su proyecto!",
            ],
            readMore: "Más información",
          }}
        />

        <AboutSection
          texts={{
            title: "NetBasis International - drive to excellence with excellent drivers!",
            paragraph1:
              "Como expertos reconocidos con sede en Alemania –el mercado europeo más importante–, el equipo de NetBasis International le ayuda a identificar las barreras de entrada, evaluar las opciones estratégicas, desarrollar conceptos de marketing realistas, encontrar los socios adecuados y contactar directamente con clientes potenciales. De forma fiable y orientada a resultados, le ofrecemos una amplia gama de servicios: desde la planificación de la entrada y el desarrollo de mercado, pasando por ventas, marketing y relaciones públicas, hasta el soporte técnico y la adquisición de talento.",
            paragraph2:
              "Al trabajar con nosotros, se beneficia de un punto de contacto único para todo su proyecto. Obtiene acceso inmediato al know-how indispensable y a la experiencia operativa necesarios para su éxito comercial. Con nuestro enfoque pragmático, trabajamos juntos para definir las condiciones y requisitos específicos de sus países objetivo.",
            paragraph3:
              "Usted tiene la opción de decidir cómo utilizar nuestra experiencia: Podemos asumir la totalidad del proyecto y actuar como su verdadera estructura local sobre el terreno durante un período determinado o indefinido. Alternativamente, le apoyamos de forma selectiva en misiones individuales, le acompañamos de manera puramente consultiva como asesores en su propio camino, o cooperamos con usted en el área de formación y coaching.",
            paragraph4:
              "Independientemente de los servicios que elija: NetBasis International coordina a la perfección todos los recursos y medidas para impulsar su negocio de forma eficiente.",
            strong_name: "NetBasis International",
          }}
        />

        <ContactCTA
          texts={{
            title: "Póngase en contacto con nosotros directamente ahora.",
            cta_button: "Formulario de contacto",
            link_url: "/es/contacto",
          }}
        />
      </main>

      <Footer />
    </div>
  );
}